import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function GetAFreeMigrationAssessment() {
  return <section className="relative bg-background py-20 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409748/img/migration_assessment_background_pattern.png)] bg-cover bg-center opacity-5"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
          {}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-light-background border border-accent/20 mb-6">
            <span className="text-sm font-semibold text-accent">Limited Time Offer</span>
          </div>

          {}
          <h2 className="text-4xl lg:text-5xl font-display font-bold text-foreground mb-6 tracking-tight">
            Get a Free Migration Assessment
          </h2>

          {}
          <p className="text-lg lg:text-xl text-foreground/70 leading-relaxed mb-10 max-w-2xl mx-auto">
            Discover how GP2BC Express can transform your Microsoft Dynamics GP to Dynamics 365 Business Central migration. Our experts will analyze your current setup and provide a tailored migration roadmap—completely free.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up-delay-100">
            <Link to="/ContactPage">
              <Button size="lg" className="bg-accent text-white hover:bg-accent-hover active:bg-accent-active shadow-medium hover:shadow-strong hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] px-8 py-6 text-base font-semibold rounded-md group">
                Request Your Free Assessment
                <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform duration-[var(--duration-fast)]" />
              </Button>
            </Link>
            
            <Link to="/PricingPage">
              <Button variant="outline" size="lg" className="px-8 py-6 text-base font-semibold rounded-md hover:bg-primary-light-background hover:border-primary transition-all duration-[var(--duration-medium)]">
                View Pricing Tiers
              </Button>
            </Link>
          </div>

          {}
          <div className="mt-10 animate-fade-in-up-delay-200">
            <div className="bg-gradient-to-br from-accent-light-background to-accent-light-background/50 border-2 border-accent/30 rounded-lg p-6 shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-accent">
                      <line x1="12" x2="12" y1="2" y2="22"></line>
                      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                  </div>
                  <div className="text-left">
                    <h3 className="text-lg font-semibold text-foreground">US-Based Businesses Save Big!</h3>
                    <p className="text-sm text-foreground/70">Benefit from favorable CAD exchange rates</p>
                  </div>
                </div>
                <Link to="#currency-savings">
                  <Button variant="default" className="bg-accent text-white hover:bg-accent-hover shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] whitespace-nowrap">
                    Learn More
                    <ArrowRight className="ml-2 size-4" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="mt-12 pt-8 border-t border-border animate-fade-in-up-delay-200">
            <div className="flex flex-wrap items-center justify-center gap-8 text-sm text-foreground/60">
              <div className="flex items-center gap-2" data-index={0}>
                <svg className="size-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">No obligation</span>
              </div>
              <div className="flex items-center gap-2" data-index={1}>
                <svg className="size-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Response within 24 hours</span>
              </div>
              <div className="flex items-center gap-2" data-index={2}>
                <svg className="size-5 text-accent" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Trusted by 100+ businesses</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}